// Shared parsing utilities used by all mappers

/** Safely parse JSON strings or return the value if it's already an object */
export function safeParse(value: any): any {
  if (typeof value === 'string') {
    let cleanValue = value.trim();
    if (cleanValue.startsWith('"') && cleanValue.endsWith('"')) {
      cleanValue = cleanValue.slice(1, -1);
      cleanValue = cleanValue.replace(/\\"/g, '"');
    }
    try {
      return JSON.parse(cleanValue);
    } catch {
      try {
        return JSON.parse(value);
      } catch {
        return value;
      }
    }
  }
  return value;
}

/** Filter skills with score >= 60 and sort descending */
export function filterAndSortSkills(
  skills: { name: string; level: number; category?: string; evidence?: string }[]
) {
  return skills.filter(s => s.level >= 60).sort((a, b) => b.level - a.level);
}
